import { MouseEvent } from 'react';
import { Channel } from 'talkplus-sdk/dist/model/types';
import AllChatList from '@components/chat/common/allChatList';
import MyChat from '@components/chat/chatList/myChat';
import ChatName from '@components/chat/chatList/chatName';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface ChatListProps {
  handleChannelClick: (channel: Channel) => void;
  handleMenuPosition: (event: MouseEvent<HTMLElement>) => void;
}

const ChatList = ({ handleChannelClick, handleMenuPosition }: ChatListProps) => {
  return (
    <div className={cx('chatListArea')}>
      <ChatName />
      <MyChat handleChannelClick={handleChannelClick} handleMenuPosition={handleMenuPosition} />
      <AllChatList handleChannelClick={handleChannelClick} />
    </div>
  );
};

export default ChatList;
